import React, { useEffect, useState, useRef, useMemo } from "react";
import Loader from "../../../Loader";
import { Link, useParams, useNavigate, useLocation } from "react-router-dom";
import Select, { components } from "react-select";
import DatePickerSample from "../../../DatePicker";
import ListInfo from "../../BookModule/BookModule.module.css";
import moment from "moment";
import { LocalizationProvider, MobileTimePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";
import styles from "./PanelInfoCreate.module.css";
import { AxiosInstance } from "../../../../../axios";
import toast from "react-hot-toast";
import Pagination from "../../../../ReusuableComponent/Pagination/Pagination";
import { customStyles } from "../../../../../pages/customStyles";
import { Search, AccessTime } from "@mui/icons-material";
import Chip from "@mui/material/Chip";
import Paper from "@mui/material/Paper";
import { styled } from "@mui/material/styles";
import { Modal } from "react-bootstrap";
import { Client } from "@microsoft/microsoft-graph-client";
import { getAccessToken } from "../../../../../labels/msalConfig";

const CheckboxOption = (props) => {
  return (
    <components.Option {...props}>
      <div
        {...props.innerProps}
        style={{ display: "flex", alignItems: "center" }}
      >
        <input
          type="checkbox"
          checked={props.isSelected}
          readOnly
          style={{ marginRight: 8 }}
        />
        <label>{props.label}</label>
      </div>
    </components.Option>
  );
};

const userJSON = sessionStorage.getItem("userDetails");
let userid = null;

if (userJSON) {
  const user = JSON.parse(userJSON);
  if (user && user.user_id) {
    userid = user.user_id;
  }
} else {
  console.log("UserId Not available");
}
// Custom styles for Time Slot Select
const timeSlotSelectStyle = {
  control: (provided, state) => ({
    ...provided,
    minHeight: "32px",
    height: "32px",
    minWidth: "150px",
    borderColor: state.isFocused ? "#86b7fe" : "#ced4da",
    boxShadow: state.isFocused
      ? "0 0 0 0.25rem rgba(13, 110, 253, 0.25)"
      : "none",
    "&:hover": {
      borderColor: state.isFocused ? "#86b7fe" : "#ced4da",
    },
    cursor: "pointer",
  }),
  valueContainer: (provided) => ({
    ...provided,
    height: "32px",
    padding: "0 8px",
  }),
  input: (provided) => ({
    ...provided,
    margin: "0px",
    padding: "0px",
  }),
  indicatorSeparator: () => ({
    display: "none",
  }),
  indicatorsContainer: (provided) => ({
    ...provided,
    height: "32px",
  }),
  dropdownIndicator: (provided) => ({
    ...provided,
    color: "#0d6efd",
    padding: "4px",
    "&:hover": {
      color: "#0d6efd",
    },
  }),
  option: (provided, state) => ({
    ...provided,
    backgroundColor: state.isSelected
      ? "#e7f1ff"
      : state.isFocused
      ? "#f8f9fa"
      : "white",
    color: "#212529",
    cursor: "pointer",
    fontSize: "14px",
    padding: "8px 12px",
    "&:active": {
      backgroundColor: "#e7f1ff",
    },
  }),
  singleValue: (provided) => ({
    ...provided,
    color: "#212529",
    fontSize: "14px",
  }),
  placeholder: (provided) => ({
    ...provided,
    color: "#6c757d",
    fontSize: "14px",
  }),
  menu: (provided) => ({
    ...provided,
    zIndex: 9999,
    minWidth: "180px",
  }),
};

// Styled ListItem for Chips
const ListItem = styled("li")(({ theme }) => ({
  margin: theme.spacing(0.5),
}));

function PanelInfoCreate() {
  const location = useLocation();
  const {
    BATCH_ID,
    CATEGORY_COURSE_ID,
    CATEGORY,
    INTERVIEW_ID,
    INTERVIEW_NAME,
    INTERVIEW_DATE,
    OTHERAPPBATCH,
    CLASSMODE,
    TYPE,
    BATCH_NAME,
  } = location.state || {};
  const [isLoading, setIsLoading] = useState(false);
  const { id } = useParams();
  const mode = localStorage.getItem("CLASSMODE");
  const navigate = useNavigate();
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [otherBatchOptions, setOtherBatchOptions] = useState([]);
  const [staff, setStaff] = useState([]);
  const [coreSubjectOptions, setCoreSubjectOptions] = useState([]);

  // Error State
  const [error, setError] = useState({});
  // Pagination State for Enrolled Students
  const [currentPage, setCurrentPage] = useState(1);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  // Selected Students State
  const [selectedStudentIds, setSelectedStudentIds] = useState([]);

  // Loading state for student list
  const [isStudentListLoading, setIsStudentListLoading] = useState(false);
  // Initial loading state for default student list
  const [isInitialStudentLoading, setIsInitialStudentLoading] = useState(true);
  // Current batch_id for API calls
  const [currentBatchId, setCurrentBatchId] = useState(
    BATCH_ID ? [BATCH_ID] : []
  );
  const [selectedOtherApplicableBatch, setSelectedOtherApplicableBatch] =
    useState([]);

  // ============== SORTING STATES ==============
  const [sortOrder, setSortOrder] = useState("asc");
  const [sortColumn, setSortColumn] = useState("");

  // ============== FILTER STATES ==============
  // Filter refs
  const filterRef_batchName = useRef(null);
  const filterRef_gender = useRef(null);
  const filterRef_medium = useRef(null);
  const filterRef_coreSubject = useRef(null);
  const txtBSearch_coreSubj = useRef(null);
  const txtBSearch_batch = useRef(null);

  // Filter selected values
  const [batchName_on, setBatchName_on] = useState([]);
  const [gender_on, setGender_on] = useState([]);
  const [medium_on, setMedium_on] = useState([]);
  const [coreSubject_on, setCoreSubject_on] = useState([]);

  // Filter dropdown open states
  const [isFilterOpen, setIsFilterOpen] = useState({
    batchName: false,
    gender: false,
    medium: false,
    coreSubject: false,
  });
  // NEW STATE: Current batch name for modal display
  const [currentBatchName, setCurrentBatchName] = useState(BATCH_NAME || "");

  // Chip data for applied filters
  const [updateChipData, setUpdateChipData] = useState([]);

  // Original student data (unfiltered) - for extracting filter options
  const [originalStudentData, setOriginalStudentData] = useState([]);

  // Dynamic filter options from API data
  const [batchNameOptions, setBatchNameOptions] = useState([]);
  const [batchNameFilteredOptions, setBatchNameFilteredOptions] = useState([]);
  const [coreSubjectFilterOptions, setCoreSubjectFilterOptions] = useState([]);
  const [coreSubjectFilteredOptions, setCoreSubjectFilteredOptions] = useState(
    []
  );

  const navigateToPreviousScreen = () => {
    navigate(-1);
  };

  // Static filter options
  const genderOptions = [
    { id: "Male", name: "Male" },
    { id: "Female", name: "Female" },
  ];

  const mediumOptions = [
    { id: "Tamil", name: "Tamil" },
    { id: "English", name: "English" },
  ];

  // ============== END FILTER STATES ==============

  // Refs for focusing error fields
  const panelNameRef = useRef(null);
  const panelExpertsRef = useRef(null);
  const venueRef = useRef(null);
  const venueUrlRef = useRef(null);
  const coreSubjectsRef = useRef(null);
  const interviewDateRef = useRef(null);
  const startTimeRef = useRef(null);
  const endTimeRef = useRef(null);
  const slotDurationRef = useRef(null);

  // Time Slot Options
  const [timeSlotOptions, setTimeSlotOptions] = useState([]);

  // Enrolled Students Data
  const [enrolledStudents, setEnrolledStudents] = useState([]);

  // Form State
  const [formData, setFormData] = useState({
    batch_id: BATCH_ID || "",
    interview_id: INTERVIEW_ID || "",
    panel_name: "",
    panel_venue: "",
    panel_venue_url: "",
    core_subject: [],
    interview_date: INTERVIEW_DATE || "",
    start_time: "",
    end_time: "",
    slot_duration: "",
    other_applicable_batches: [],
    panel_member_id: [],
    created_by: "",
    students_enrolled: [],
    hall_ticket_status: "",
  });

  useEffect(() => {
    // if (!BATCH_ID || !INTERVIEW_ID) return;

    setCurrentBatchId([BATCH_ID]);
    fetchCoreSubjects();
    fetchOtherApplicableBatches();
    if (!id) {
      fetchStudentListWithFilters(currentBatchId);
    }
  }, [BATCH_ID, INTERVIEW_ID]);

  useEffect(() => {
    if (
      !Array.isArray(OTHERAPPBATCH) ||
      (OTHERAPPBATCH && OTHERAPPBATCH?.length === 0)
    ) {
      return;
    }

    const otherBatchIds = OTHERAPPBATCH.map((b) => b.batch_id);

    const combinedBatchIds = Array.from(new Set([BATCH_ID, ...otherBatchIds]));

    setCurrentBatchId(combinedBatchIds);

    // 2️⃣ Prepare react-select formatted options
    const formattedOtherBatches = OTHERAPPBATCH.map((batch) => ({
      value: batch.batch_id,
      label: batch.batch_name,
    }));

    setSelectedOtherApplicableBatch(formattedOtherBatches);
    fetchStudentListWithFilters(combinedBatchIds);
  }, [OTHERAPPBATCH, BATCH_ID]);

  // Fetch Staff
  useEffect(() => {
    AxiosInstance.post(`api/staff/allSupervisor`, {})
      .then((res) => {
        if (res.data.status === true && Array.isArray(res.data.data)) {
          const groupedMembers = res.data.data.reduce((acc, s) => {
            const type = String(s.staff_type);
            if (!acc[type]) acc[type] = [];
            acc[type].push(s);
            return acc;
          }, {});

          const formattedStaff = Object.keys(groupedMembers).map((type) => ({
            label:
              type === "0"
                ? "Faculty"
                : type === "1"
                ? "Staff"
                : "Panel Member",
            options: groupedMembers[type].map((s) => ({
              value: s.id,
              label: s.full_name,
              email: s.email,
            })),
          }));
          setStaff(formattedStaff);
        }
      })
      .catch((err) => console.log("Class Staff API Error:", err));
  }, []);

  const sortedStaff = useMemo(() => {
    return [...staff].sort((a, b) => a.label.localeCompare(b.label));
  }, [staff]);

  const handlechangeSelectDropdown = (options, name) => {
    const selectedOptions = options || [];
    setSelectedOtherApplicableBatch(selectedOptions);
    const selectedBatchIds = selectedOptions.map((opt) => opt.value);

    setCurrentBatchId((prev = []) => {
      const baseIds = BATCH_ID ? [BATCH_ID] : [];

      const updatedIds = prev.filter(
        (id) => id === BATCH_ID || selectedBatchIds.includes(id)
      );

      selectedBatchIds.forEach((id) => {
        if (!updatedIds.includes(id)) {
          updatedIds.push(id);
        }
      });

      return Array.from(new Set([...baseIds, ...updatedIds]));
    });
  };

  const fetchCoreSubjects = async () => {
    try {
      const res = await AxiosInstance.post("/api/all/getCoreSubject");
      if (res.data?.status && Array.isArray(res.data.data)) {
        const formattedOptions = res.data.data.map((item) => ({
          value: item.id,
          label: item.subject,
        }));
        setCoreSubjectOptions(formattedOptions);
      }
    } catch (error) {
      console.error("Error fetching core subjects:", error);
    }
  };

  // Fetch Other Applicable Batches
  const fetchOtherApplicableBatches = async () => {
    try {
      const payload = {
        category: CATEGORY,
        course_id: CATEGORY_COURSE_ID,
        batch_id: BATCH_ID,
        interview_date: new Date(INTERVIEW_DATE).toISOString().split("T")[0],
      };

      const res = await AxiosInstance.post(
        "api/mockinterview/interview/other_applicable_list",
        payload
      );

      if (res.data?.status && Array.isArray(res.data.data)) {
        const formatted = res.data.data.map((item, index) => ({
          value: item.id,
          label: `${item.name} (${item.class_mode})`,
          name: item.name,
          class_mode: item.class_mode,
          category: item.category,
          category_class: item.category_class,
          paper_type: item.paper_type,
        }));

        setOtherBatchOptions(formatted);
        return formatted;
      }
    } catch (error) {
      console.error("Error fetching applicable batches:", error);
    }
  };

  // ============== SORTING FUNCTION ==============
  // ============== SORTING FUNCTION ==============
  const handleSort = (event, sortKey) => {
    event.preventDefault();

    // Determine the new sort order
    let newSortOrder;
    if (sortColumn === sortKey) {
      newSortOrder = sortOrder === "asc" ? "desc" : "asc";
    } else {
      newSortOrder = "asc";
    }

    setSortOrder(newSortOrder);
    setSortColumn(sortKey);

    const sortedList = [...enrolledStudents].sort((a, b) => {
      const aVal = a[sortKey] ?? "";
      const bVal = b[sortKey] ?? "";

      const aNum = typeof aVal === "number" ? aVal : parseFloat(aVal);
      const bNum = typeof bVal === "number" ? bVal : parseFloat(bVal);

      if (!isNaN(aNum) && !isNaN(bNum)) {
        if (aNum < bNum) {
          return newSortOrder === "asc" ? -1 : 1;
        }
        if (aNum > bNum) {
          return newSortOrder === "asc" ? 1 : -1;
        }
        return 0;
      }

      const aStr = String(aVal).toLowerCase();
      const bStr = String(bVal).toLowerCase();

      if (aStr < bStr) {
        return newSortOrder === "asc" ? -1 : 1;
      }
      if (aStr > bStr) {
        return newSortOrder === "asc" ? 1 : -1;
      }
      return 0;
    });
    setEnrolledStudents(sortedList);
  };

  // ============== API FILTER FUNCTIONS ==============

  // Build filter payload from chip data
  // const buildFilterPayload = (chips) => {
  //   const filters = {
  //     gender: "",
  //     batch_name: "",
  //     core_sub: "",
  //     medium: "",
  //      medium_studied: "",
  //   };

  //   // Get filter values from chips
  //   const genderChips = chips.filter((c) => c.type === "gender");
  //   const batchChips = chips.filter((c) => c.type === "batchName");
  //   const coreSubjectChips = chips.filter((c) => c.type === "coreSubject");
  //   const mediumChips = chips.filter((c) => c.type === "medium");

  //   // Set gender filter (single value)
  //   if (genderChips.length > 0) {
  //     filters.gender = genderChips[0].id;
  //   }

  //   // Set batch_name filter (comma separated for multiple)
  //   if (batchChips.length > 0) {
  //     filters.batch_name = batchChips.map((c) => c.name).join(",");
  //   }

  //   // Set core_sub filter (comma separated for multiple)
  //   if (coreSubjectChips.length > 0) {
  //     filters.core_sub = coreSubjectChips.map((c) => c.id).join(",");
  //   }

  //   // Set medium filter (single value)
  //   if (mediumChips.length > 0) {
  //     filters.medium = mediumChips[0].id;
  //   }

  //   return filters;
  // };

  // Build filter payload from chip data
  const buildFilterPayload = (chips) => {
    const filters = {
      gender: "",
      batch_name: "",
      core_sub: "",
      core_subject: "",
      medium: "",
      medium_studied: "",
    };

    // Get filter values from chips
    const genderChips = chips.filter((c) => c.type === "gender");
    const batchChips = chips.filter((c) => c.type === "batchName");
    const coreSubjectChips = chips.filter((c) => c.type === "coreSubject");
    const mediumChips = chips.filter((c) => c.type === "medium");
    // Set gender filter (single value)
    if (genderChips.length > 0) {
      filters.gender = genderChips[0].id;
    }

    // Set batch_name filter (comma separated for multiple)
    if (batchChips.length > 0) {
      filters.batch_name = batchChips.map((c) => c.name).join(",");
    }

    // Set core_sub filter (comma separated for multiple)
    if (coreSubjectChips.length > 0) {
      const coreSubValue = coreSubjectChips.map((c) => c.id).join(",");
      filters.core_sub = coreSubValue;
      filters.core_subject = coreSubValue;
    }

    // Set medium filter (single value)
    if (mediumChips.length > 0) {
      filters.medium = mediumChips[0].id;
      filters.medium_studied = mediumChips[0].id;
    }

    return filters;
  };
  // Fetch Student List with filters - API based filtering
  const fetchStudentListWithFilters = async (batchId, filters = {}) => {
    setIsStudentListLoading(true);
    try {
      const payload = {
        batch_id: batchId,
        gender: filters.gender ? [filters.gender] : "",
        batch_name: filters.batch_name ? [filters.batch_name] : "",
        core_sub: filters.core_sub ? [filters.core_sub] : "",
        medium: filters.medium ? [filters.medium] : "",
        interview_id: INTERVIEW_ID,
      };
      const res = await AxiosInstance.post(
        "api/mockinterview/panel/studentList",
        payload
      );

      if (res.data?.status && Array.isArray(res.data.data)) {
        const studentsWithTimeSlot = res.data.data.map((student, index) => ({
          ...student,
          time_slot: "",
          serialNumber: index + 1,
        }));
        setEnrolledStudents(studentsWithTimeSlot);
        setCurrentPage(1);

        if (
          !filters.gender &&
          !filters.batch_name &&
          !filters.core_sub &&
          !filters.medium
        ) {
          setOriginalStudentData(studentsWithTimeSlot);
          extractFilterOptionsFromData(studentsWithTimeSlot);
        }
      } else {
        setEnrolledStudents([]);
      }
    } catch (error) {
      console.error("Error fetching student list:", error);
      setEnrolledStudents([]);
    } finally {
      setIsStudentListLoading(false);
      setIsInitialStudentLoading(false);
    }
  };

  // Extract filter options from student data
  const extractFilterOptionsFromData = (data) => {
    if (!data || data.length === 0) return;

    // Extract unique batch names
    const seenBatchIds = new Set();
    const batchOptions = data
      .filter((item) => {
        if (!item.batch_name || seenBatchIds.has(item.batch_id)) {
          return false;
        }
        seenBatchIds.add(item.batch_id);
        return true;
      })
      .map((item) => ({
        id: item.batch_id,
        name: item.batch_name,
      }));
    setBatchNameOptions(batchOptions);
    setBatchNameFilteredOptions(batchOptions);

    // Extract unique core subjects
    const seenCoreSubjects = new Set();
    const coreSubjectOpts = data
      .filter((item) => {
        if (!item.core_subject || seenCoreSubjects.has(item.core_subject)) {
          return false;
        }
        seenCoreSubjects.add(item.core_subject);
        return true;
      })
      .map((item) => ({
        id: item.core_subject,
        name: item.core_subject,
      }));
    setCoreSubjectFilterOptions(coreSubjectOpts);
    setCoreSubjectFilteredOptions(coreSubjectOpts);
  };

  // ============== END API FILTER FUNCTIONS ==============

  // Pagination Calculations
  const start = (currentPage - 1) * rowsPerPage;
  const end = start + rowsPerPage;
  const currentStudentData = enrolledStudents?.slice(start, end);
  const totalPages = Math.ceil(enrolledStudents?.length / rowsPerPage);

  // Min date for DatePicker (today's date)
  const minDate = new Date();

  // URL validation regex
  const urlRegex =
    /^(https?:\/\/)?(www\.)?([a-zA-Z0-9-]+\.)+[a-zA-Z]{2,}(\/[^\s]*)?$/;

  // Check if Save Panel button should be enabled
  const isSavePanelEnabled = () => {
    if (selectedStudentIds.length === 0) {
      return false;
    }
    const selectedStudents = enrolledStudents.filter((student) =>
      selectedStudentIds.includes(student.user_id)
    );
    const allHaveTimeSlot = selectedStudents.every(
      (student) => student.time_slot && student.time_slot.trim() !== ""
    );
    return allHaveTimeSlot;
  };

  // Handle Individual Student Checkbox
  const handleStudentCheckbox = (id) => {
    if (selectedStudentIds.includes(id)) {
      setSelectedStudentIds((prev) =>
        prev.filter((studentId) => studentId !== id)
      );
    } else {
      setSelectedStudentIds((prev) => [...prev, id]);
    }
  };

  // Function to format time to 12-hour format with AM/PM
  const formatTimeTo12Hour = (time24) => {
    const [hours, minutes] = time24.split(":");
    let hour = parseInt(hours, 10);
    const ampm = hour >= 12 ? "PM" : "AM";
    hour = hour % 12;
    hour = hour ? hour : 12;
    const formattedHour = hour.toString().padStart(2, "0");
    const formattedMinutes = minutes.padStart(2, "0");
    return `${formattedHour}:${formattedMinutes} ${ampm}`;
  };

  const [open, setOpen] = useState(false);

  const handleModelClose = () => {
    setOpen(false);
  };
  const handleModeSubmit = () => {
    setOpen(false);
    fetchStudentListWithFilters(currentBatchId);
  };

  // Function to generate time slots
  const generateTimeSlots = (startTime, endTime, duration) => {
    const slots = [];
    if (!startTime || !endTime || !duration) {
      return slots;
    }
    const durationMinutes = parseInt(duration, 10);
    if (isNaN(durationMinutes) || durationMinutes < 10) {
      return slots;
    }
    const [startHour, startMinute] = startTime.split(":").map(Number);
    const [endHour, endMinute] = endTime.split(":").map(Number);
    let currentHour = startHour;
    let currentMinute = startMinute;
    const endTotalMinutes = endHour * 60 + endMinute;

    while (true) {
      const currentTotalMinutes = currentHour * 60 + currentMinute;
      let nextTotalMinutes = currentTotalMinutes + durationMinutes;
      if (nextTotalMinutes > endTotalMinutes) {
        break;
      }
      const nextHour = Math.floor(nextTotalMinutes / 60);
      const nextMinute = nextTotalMinutes % 60;
      const slotStart = `${currentHour
        .toString()
        .padStart(2, "0")}:${currentMinute.toString().padStart(2, "0")}`;
      const slotEnd = `${nextHour.toString().padStart(2, "0")}:${nextMinute
        .toString()
        .padStart(2, "0")}`;
      const formattedStart = formatTimeTo12Hour(slotStart);
      const formattedEnd = formatTimeTo12Hour(slotEnd);
      const slotLabel = `${formattedStart} - ${formattedEnd}`;
      slots.push({
        value: slotLabel,
        label: slotLabel,
      });
      currentHour = nextHour;
      currentMinute = nextMinute;
    }
    return slots;
  };

  // Get available slots for a student
  const getAvailableSlotsForStudent = (admissionId) => {
    const selectedSlots = enrolledStudents
      .filter(
        (student) => student.admission_id !== admissionId && student.time_slot
      )
      .map((student) => student.time_slot);
    return timeSlotOptions.filter(
      (slot) => !selectedSlots.includes(slot.value)
    );
  };

  // Validation function
  const validateFields = (data) => {
    const errors = {};
    if (!data.panel_name || data.panel_name.trim() === "") {
      errors.panel_name = "Please enter panel name";
    }
    if (!data.panel_venue || data.panel_venue.trim() === "") {
      errors.panel_venue = "Please enter venue";
    }
    // Add Panel Experts validation
    if (!data.panel_member_id || data.panel_member_id.length === 0) {
      errors.panel_member_id = "Please select at least one panel expert";
    }
    if (!data.panel_venue || data.panel_venue.trim() === "") {
      errors.panel_venue = "Please enter venue";
    }
    // New (required field)
    if (!data.panel_venue_url || data.panel_venue_url.trim() === "") {
      errors.panel_venue_url = "Please enter venue URL";
    } else if (!urlRegex.test(data.panel_venue_url.trim())) {
      errors.panel_venue_url = "Please enter a valid URL";
    }

    if (!data.core_subject || data.core_subject.length === 0) {
      errors.core_subject = "Please select at least one core subject";
    }
    if (!data.interview_date) {
      errors.interview_date = "Please select interview date";
    }
    if (!data.start_time) {
      errors.start_time = "Please select start time";
    }
    if (!data.end_time) {
      errors.end_time = "Please select end time";
    }
    if (data.start_time && data.end_time) {
      const startMoment = dayjs(data.start_time, "HH:mm:ss");
      const endMoment = dayjs(data.end_time, "HH:mm:ss");
      if (endMoment.isBefore(startMoment) || endMoment.isSame(startMoment)) {
        errors.end_time = "End time must be after start time";
      }
    }
    if (!data.slot_duration) {
      errors.slot_duration = "Please enter slot duration";
    } else if (data.slot_duration.length < 2) {
      errors.slot_duration =
        "Slot duration must be at least 2 digits (e.g., 10, 15, 30)";
    } else {
      const durationNum = parseInt(data.slot_duration, 10);
      if (isNaN(durationNum) || durationNum < 10) {
        errors.slot_duration = "Slot duration must be at least 10 minutes";
      } else if (durationNum > 480) {
        errors.slot_duration =
          "Slot duration cannot exceed 480 minutes (8 hours)";
      }
    }
    return errors;
  };

  // Handle Input Change
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    setError({
      ...error,
      [name]: "",
    });
  };

  // Handle Venue URL Change with validation
  const handleVenueUrlChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (value && value.trim() !== "") {
      if (!urlRegex.test(value.trim())) {
        setError((prev) => ({
          ...prev,
          panel_venue_url: "Please enter a valid URL",
        }));
      } else {
        setError((prev) => ({
          ...prev,
          panel_venue_url: "",
        }));
      }
    } else {
      setError((prev) => ({
        ...prev,
        panel_venue_url: "",
      }));
    }
  };

  // Handle Slot Duration Change
  const handleSlotDurationChange = (e) => {
    const { name, value } = e.target;
    if (value && !/^\d*$/.test(value)) {
      return;
    }
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
    if (!value) {
      setError({
        ...error,
        slot_duration: "Please enter slot duration",
      });
    } else if (value.length < 2) {
      setError({
        ...error,
        slot_duration:
          "Slot duration must be at least 2 digits (e.g., 10, 15, 30)",
      });
    } else {
      const durationNum = parseInt(value, 10);
      if (isNaN(durationNum) || durationNum < 10) {
        setError({
          ...error,
          slot_duration: "Slot duration must be at least 10 minutes",
        });
      } else if (durationNum > 480) {
        setError({
          ...error,
          slot_duration: "Slot duration cannot exceed 480 minutes (8 hours)",
        });
      } else {
        setError({
          ...error,
          slot_duration: "",
        });
      }
    }
  };

  // Handle Core Subject Multi-Select Change
  const handleCoreSubjectChange = (selectedOptions) => {
    setFormData((prev) => ({
      ...prev,
      core_subject: selectedOptions || [],
    }));
    setError((prev) => ({
      ...prev,
      core_subject: "",
    }));
  };

  // Handle Panel Member Multi-Select Change
  const handlePanelMemberChange = (selectedOptions) => {
    setFormData((prev) => ({
      ...prev,
      panel_member_id: selectedOptions || [],
    }));
    setError((prev) => ({
      ...prev,
      panel_member_id: "",
    }));
  };

  // Handle Date Change
  const handleDateChange = (date) => {
    const formattedDate = date ? moment(date).format("YYYY-MM-DD") : "";
    setFormData((prev) => ({
      ...prev,
      interview_date: formattedDate,
    }));
    setError({
      ...error,
      interview_date: "",
    });
  };

  // Handle Time Change
  const handleTimeChange = (name, time) => {
    const timeValue = time ? dayjs(time).format("HH:mm:ss") : "";
    setFormData((prev) => ({
      ...prev,
      [name]: timeValue,
    }));
    setError({
      ...error,
      [name]: "",
    });
    if (name === "end_time" && formData.start_time && timeValue) {
      const startMoment = dayjs(formData.start_time, "HH:mm:ss");
      const endMoment = dayjs(timeValue, "HH:mm:ss");
      if (endMoment.isBefore(startMoment) || endMoment.isSame(startMoment)) {
        setError((prev) => ({
          ...prev,
          end_time: "End time must be after start time",
        }));
      }
    }
    if (name === "start_time" && formData.end_time && timeValue) {
      const startMoment = dayjs(timeValue, "HH:mm:ss");
      const endMoment = dayjs(formData.end_time, "HH:mm:ss");
      if (endMoment.isBefore(startMoment) || endMoment.isSame(startMoment)) {
        setError((prev) => ({
          ...prev,
          start_time: "Start time must be before end time",
        }));
      }
    }
  };

  // Handle Time Slot Change for Student
  const handleTimeSlotChange = (admissionId, selectedOption) => {
    setEnrolledStudents((prev) =>
      prev.map((student) =>
        student.user_id === admissionId
          ? {
              ...student,
              time_slot: selectedOption ? selectedOption.value : "",
            }
          : student
      )
    );
  };

  // Generate Student List Handler
  const handleGenerateStudentList = () => {
    setOpen(true);
  };

  // Pagination Handlers
  const handlePrev = (val) => {
    setCurrentPage(val);
  };

  const handleNext = (val) => {
    setCurrentPage(val);
  };

  const handlePageCount = (e) => {
    setRowsPerPage(Number(e.target.value));
    setCurrentPage(1);
  };

  // ============== FILTER FUNCTIONS ==============

  // Handle filter checkbox change
  const handleFilterCheckboxChange = (event, filterType) => {
    const { value, checked, name } = event.target;

    if (filterType === "batchName") {
      if (checked) {
        setBatchName_on([
          ...batchName_on,
          { id: value, name: name, type: "batchName" },
        ]);
      } else {
        setBatchName_on(batchName_on.filter((item) => item.id !== value));
      }
    } else if (filterType === "gender") {
      if (checked) {
        setGender_on([{ id: value, name: name, type: "gender" }]);
      } else {
        setGender_on(gender_on.filter((item) => item.id !== value));
      }
    } else if (filterType === "medium") {
      if (checked) {
        setMedium_on([{ id: value, name: name, type: "medium" }]);
      } else {
        setMedium_on(medium_on.filter((item) => item.id !== value));
      }
    } else if (filterType === "coreSubject") {
      if (checked) {
        setCoreSubject_on([
          ...coreSubject_on,
          { id: value, name: name, type: "coreSubject" },
        ]);
      } else {
        setCoreSubject_on(coreSubject_on.filter((item) => item.id !== value));
      }
    }
  };

  // Handle filter toggle
  const handleFilterToggle = (e, filterName) => {
    if (filterName === "batchName") {
      setIsFilterOpen((prevState) => ({
        batchName: !prevState.batchName,
        gender: false,
        medium: false,
        coreSubject: false,
      }));
      setBatchName_on(updateChipData.filter((ui) => ui.type === "batchName"));
    } else if (filterName === "gender") {
      setIsFilterOpen((prevState) => ({
        batchName: false,
        gender: !prevState.gender,
        medium: false,
        coreSubject: false,
      }));
      setGender_on(updateChipData.filter((ui) => ui.type === "gender"));
    } else if (filterName === "medium") {
      setIsFilterOpen((prevState) => ({
        batchName: false,
        gender: false,
        medium: !prevState.medium,
        coreSubject: false,
      }));
      setMedium_on(updateChipData.filter((ui) => ui.type === "medium"));
    } else if (filterName === "coreSubject") {
      setIsFilterOpen((prevState) => ({
        batchName: false,
        gender: false,
        medium: false,
        coreSubject: !prevState.coreSubject,
      }));
      setCoreSubject_on(
        updateChipData.filter((ui) => ui.type === "coreSubject")
      );
    }
  };

  // Apply filter - API based
  const handleApplyFilter = (filterName) => {
    let tempArr = [...updateChipData];

    if (filterName === "batchName") {
      tempArr = tempArr.filter((item) => item.type !== "batchName");
      batchName_on.forEach((item) => tempArr.push(item));
      setIsFilterOpen({ ...isFilterOpen, batchName: false });
    } else if (filterName === "gender") {
      tempArr = tempArr.filter((item) => item.type !== "gender");
      gender_on.forEach((item) => tempArr.push(item));
      setIsFilterOpen({ ...isFilterOpen, gender: false });
    } else if (filterName === "medium") {
      tempArr = tempArr.filter((item) => item.type !== "medium");
      medium_on.forEach((item) => tempArr.push(item));
      setIsFilterOpen({ ...isFilterOpen, medium: false });
    } else if (filterName === "coreSubject") {
      tempArr = tempArr.filter((item) => item.type !== "coreSubject");
      coreSubject_on.forEach((item) => tempArr.push(item));
      setIsFilterOpen({ ...isFilterOpen, coreSubject: false });
    }

    setUpdateChipData(tempArr);

    const filterPayload = buildFilterPayload(tempArr);

    // Determine which API to call based on mode (Create vs Edit)
    if (!id) {
      // CREATE MODE: Fetch student list for panel creation
      fetchStudentListWithFilters(currentBatchId, filterPayload);
    } else {
      // EDIT MODE: Fetch panel data with filters applied
      fetchPanelDataWithFilters(filterPayload);
    }

    // Close the filter dropdown
    setIsFilterOpen({ ...isFilterOpen, [filterName]: false });
  };
  useEffect(() => {
    fetchPanelDataWithFilters({}, true);
  }, []);
  // Clear specific filter - API based
  const handleClearFilter = (filterName) => {
    const updatedChips = updateChipData.filter(
      (item) => item.type !== filterName
    );
    setUpdateChipData(updatedChips);

    if (filterName === "batchName") {
      setBatchName_on([]);
      setIsFilterOpen({ ...isFilterOpen, batchName: false });
    } else if (filterName === "gender") {
      setGender_on([]);
      setIsFilterOpen({ ...isFilterOpen, gender: false });
    } else if (filterName === "medium") {
      setMedium_on([]);
      setIsFilterOpen({ ...isFilterOpen, medium: false });
    } else if (filterName === "coreSubject") {
      setCoreSubject_on([]);
      setIsFilterOpen({ ...isFilterOpen, coreSubject: false });
    }

    const filterPayload = buildFilterPayload(updatedChips);
    if (!id) {
      fetchStudentListWithFilters(currentBatchId, filterPayload);
    } else {
      fetchPanelDataWithFilters(filterPayload);
    }
  };

  // Delete chip - API based
  // const handleDeleteChip = (chipToDelete) => () => {
  //   let updatedChips = updateChipData.filter(
  //     (chip) =>
  //       !(chip.id === chipToDelete.id && chip.type === chipToDelete.type)
  //   );
  //   setUpdateChipData(updatedChips);

  //   if (chipToDelete.type === "batchName") {
  //     setBatchName_on(
  //       batchName_on.filter((item) => item.id !== chipToDelete.id)
  //     );
  //   } else if (chipToDelete.type === "gender") {
  //     setGender_on(gender_on.filter((item) => item.id !== chipToDelete.id));
  //   } else if (chipToDelete.type === "medium") {
  //     setMedium_on(medium_on.filter((item) => item.id !== chipToDelete.id));
  //   } else if (chipToDelete.type === "coreSubject") {
  //     setCoreSubject_on(
  //       coreSubject_on.filter((item) => item.id !== chipToDelete.id)
  //     );
  //   }

  //   const filterPayload = buildFilterPayload(updatedChips);
  //   fetchStudentListWithFilters(currentBatchId, filterPayload);
  // };
  // Delete chip - API based
  const handleDeleteChip = (chipToDelete) => (e) => {
    if (e) {
      e.preventDefault();
    }

    // Create a new array without the chip to delete
    const updatedChips = updateChipData.filter((chip) => {
      // Compare both id and type to uniquely identify the chip
      return !(chip.id === chipToDelete.id && chip.type === chipToDelete.type);
    });

    setUpdateChipData(updatedChips);

    // Also update the corresponding filter state
    if (chipToDelete.type === "batchName") {
      setBatchName_on(
        batchName_on.filter((item) => item.id !== chipToDelete.id)
      );
    } else if (chipToDelete.type === "gender") {
      setGender_on(gender_on.filter((item) => item.id !== chipToDelete.id));
    } else if (chipToDelete.type === "medium") {
      setMedium_on(medium_on.filter((item) => item.id !== chipToDelete.id));
    } else if (chipToDelete.type === "coreSubject") {
      setCoreSubject_on(
        coreSubject_on.filter((item) => item.id !== chipToDelete.id)
      );
    }

    // In handleDeleteChip function, after updating states:
    const filterPayload = buildFilterPayload(updatedChips);
    if (!id) {
      fetchStudentListWithFilters(currentBatchId, filterPayload);
    } else {
      fetchPanelDataWithFilters(filterPayload);
    }
  };
  // Clear all filters - API based
  const handleAllClear = () => {
    setBatchName_on([]);
    setGender_on([]);
    setMedium_on([]);
    setCoreSubject_on([]);
    setUpdateChipData([]);

    const emptyFilterPayload = {}; // Or buildFilterPayload([])
    if (!id) {
      fetchStudentListWithFilters(currentBatchId, emptyFilterPayload);
    } else {
      fetchPanelDataWithFilters(emptyFilterPayload);
    }
  };

  // Handle filter search for batch name
  const handleFilterBatchSearch = (event) => {
    const searchInput = event.target.value;
    if (searchInput !== "") {
      const matchingObjects = batchNameOptions.filter(
        (item) =>
          item.name &&
          item.name.toLowerCase().includes(searchInput.toLowerCase())
      );
      setBatchNameFilteredOptions(matchingObjects);
    } else {
      setBatchNameFilteredOptions(batchNameOptions);
    }
  };

  // Handle filter search for core subject
  const handleFilterCoreSubjectSearch = (event) => {
    const searchInput = event.target.value;
    if (searchInput !== "") {
      const matchingObjects = coreSubjectFilterOptions.filter(
        (item) =>
          item.name &&
          item.name.toLowerCase().includes(searchInput.toLowerCase())
      );
      setCoreSubjectFilteredOptions(matchingObjects);
    } else {
      setCoreSubjectFilteredOptions(coreSubjectFilterOptions);
    }
  };

  // Click outside handler for filters
  useEffect(() => {
    const handleClickOutside = (event) => {
      const isCheckbox = event.target.closest('input[type="checkbox"]');
      const isApplyFilterButton = event.target.closest(".filterBoxs_testlist");
      const isChipData = event.target.closest(".paperil_global");
      if (isCheckbox || isApplyFilterButton || isChipData) return;

      if (
        filterRef_batchName.current &&
        !filterRef_batchName.current.contains(event.target)
      ) {
        const hasBatch = updateChipData.some(
          (chipItem) => chipItem.type === "batchName"
        );
        if (hasBatch) {
          setBatchName_on(
            updateChipData.filter((chipItem) => chipItem.type === "batchName")
          );
        } else {
          setBatchName_on([]);
        }
        setIsFilterOpen((prev) => ({ ...prev, batchName: false }));
      }

      if (
        filterRef_gender.current &&
        !filterRef_gender.current.contains(event.target)
      ) {
        const hasGender = updateChipData.some(
          (chipItem) => chipItem.type === "gender"
        );
        if (hasGender) {
          setGender_on(
            updateChipData.filter((chipItem) => chipItem.type === "gender")
          );
        } else {
          setGender_on([]);
        }
        setIsFilterOpen((prev) => ({ ...prev, gender: false }));
      }

      if (
        filterRef_medium.current &&
        !filterRef_medium.current.contains(event.target)
      ) {
        const hasMedium = updateChipData.some(
          (chipItem) => chipItem.type === "medium"
        );
        if (hasMedium) {
          setMedium_on(
            updateChipData.filter((chipItem) => chipItem.type === "medium")
          );
        } else {
          setMedium_on([]);
        }
        setIsFilterOpen((prev) => ({ ...prev, medium: false }));
      }

      if (
        filterRef_coreSubject.current &&
        !filterRef_coreSubject.current.contains(event.target)
      ) {
        const hasCoreSubject = updateChipData.some(
          (chipItem) => chipItem.type === "coreSubject"
        );
        if (hasCoreSubject) {
          setCoreSubject_on(
            updateChipData.filter((chipItem) => chipItem.type === "coreSubject")
          );
        } else {
          setCoreSubject_on([]);
        }
        setIsFilterOpen((prev) => ({ ...prev, coreSubject: false }));
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [updateChipData, batchName_on, gender_on, medium_on, coreSubject_on]);

  // ============== END FILTER FUNCTIONS ==============

  const getAttendeeUserList = async (
    accessToken,
    staffEmails,
    freshStudentList
  ) => {
    const client = Client.init({
      authProvider: (done) => {
        done(null, accessToken);
      },
    });
    const matchedUsers = [];
    const combinedEmails = [...staffEmails, ...freshStudentList];
    for (const userEmail of combinedEmails) {
      try {
        if (userEmail.includes("@gmail.com")) {
          const userUPN = userEmail;
          const response = await client
            .api(`/users?$filter=mail eq '${userUPN}'`)
            .header("ConsistencyLevel", "eventual")
            .get();
          if (response) {
            // Iterate through the user objects in the response
            for (const user of response.value) {
              const { id, displayName, mail } = user;
              const matchedUserObject = {
                upn: mail,
                role: "attendee",
                identity: {
                  user: {
                    id: id,
                    displayName: displayName,
                    identityProvider: "AAD",
                  },
                },
              };

              matchedUsers.push(matchedUserObject);
            }
          } else {
            console.log(`No user found for email: ${userEmail}`);
          }
        } else if (!userEmail?.includes("@gmail.com")) {
          const response = await client
            // `/users?$filter=mail eq '${gmail}'`)
            .api(`/users?$filter=mail eq '${userEmail}'`)
            // .api(`/users/${userEmail}`)
            .header("ConsistencyLevel", "eventual")
            .get();
          if (response) {
            for (const user of response.value) {
              const { id, displayName, mail } = user;
              const matchedUserObject = {
                upn: mail,
                role: "attendee",
                identity: {
                  user: {
                    id: id,
                    displayName: displayName,
                    identityProvider: "AAD",
                  },
                },
              };

              matchedUsers.push(matchedUserObject);
            }
          } else {
            console.log(`No user found for email: ${userEmail}`);
          }
        }
      } catch (error) {
        console.log(error);
        // throw error;
      }
    }

    return matchedUsers;
  };
  //for user  match email
  const getUserMatchList = (accessToken, gmail) => {
    const client = Client.init({
      authProvider: (done) => {
        done(null, accessToken);
      },
    });

    return client
      .api(`/users?$filter=mail eq '${gmail}'`)
      .header("ConsistencyLevel", "eventual")
      .get()
      .then((response) => {
        if (response) {
          for (const user of response.value) {
            const { id, displayName, mail } = user;
            const organizer = {
              identity: {
                user: {
                  id: id,
                  displayName: displayName,
                },
              },
              role: "presenter",
              upn: mail,
            };
            // role :coorganizer checking if any need for coorganizer
            return organizer;
          }
        } else {
          console.log(`No user found for email: ${gmail}`);
        }
      })
      .catch((error) => {
        console.log(error, "geting error ");
        console.log(`No user found for email: ${gmail}`);
      });
  };
  const coorganizerEmails = formData.panel_member_id.map((item) => item.email);

  const createOnlineMeeting = async (
    accessToken,
    formData,
    freshStudentList,
    usernames
  ) => {
    try {
      const [organizer, attendees, coorganizers] = await Promise.all([
        getUserMatchList(accessToken, usernames), // main organizer
        getAttendeeUserList(accessToken, freshStudentList, []), // attendees
        getAttendeeUserList(accessToken, coorganizerEmails, []), // coorganizers
      ]);

      // Map coorganizers as presenters
      const coorganizerObjects = coorganizers.map((user) => ({
        ...user,
        role: "coorganizer", // or "coorganizer" if Graph supports in your tenant
      }));
      const onlineMeeting = {
        startDateTime: moment(
          `${formData.interview_date} ${formData.startTime}`,
          "YYYY-MM-DD HH:mm:ss"
        ).toISOString(),
        endDateTime: moment(
          `${formData.interview_date} ${formData.endTime}`,
          "YYYY-MM-DD HH:mm:ss"
        ).toISOString(),
        participants: {
          organizer: organizer,
          attendees: [...attendees, ...coorganizerObjects],
          // attendees: attendees,
        },
        accessLevel: "Restricted",
        subject: formData.core_subject.map((item) => item.label).join(","),
        joinMeetingIdSettings: {
          isPasscodeRequired: true,
        },
        lobbyBypassSettings: {
          scope: "invited",
          isDialInBypassEnabled: false,
        },
        allowedAttendees: "OrganizerAndInvitees",
        allowedPresenters: "roleIsPresenter",
        allowAttendeeToEnableMic: false,
        allowAttendeeToEnableCamera: false,
        allowTeamworkRejoin: false,
        recordAutomatically: true,
        allowTranscription: false,
        allowRecording: true,
        allowParticipantsToAccessRecording: false,
        allowParticipantsToAccessRecap: false,
      };
      return onlineMeeting;
    } catch (error) {
      console.log(error);
    }
  };
  // Handle Submit
  const handleSubmit = async (e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    if (isSubmitting) return;

    const errors = validateFields(formData);

    if (Object.keys(errors).length === 0) {
      const selectedStudentsData = enrolledStudents
        .filter((student) => selectedStudentIds.includes(student.user_id))
        .map((student) => ({
          user_id: student.user_id,
          time_slot: student.time_slot,
          batch_id: student.batch_id,
          interview_id: student.exam_detail_id,
          team_url: null,
        }));

      const coreSubjectArray = formData.core_subject.map((opt) => opt.label);
      const panelMemberArray = formData.panel_member_id.map((opt) => opt.value);

      const formatTimeForApi = (time) => {
        if (!time) return "";
        return time.substring(0, 5);
      };
      const updatedOtherApplicableBatches = selectedOtherApplicableBatch.filter(
        (id) => id !== BATCH_ID
      );
      if ((CLASSMODE || mode) === "Online") {
        const { accessToken, username } = await getAccessToken();
        const client = Client.init({
          authProvider: (done) => {
            done(null, accessToken);
          },
        });
        setIsLoading(true);
        const freshStudentList =
          (enrolledStudents.length > 0 &&
            enrolledStudents.map((item) => item.email)) ||
          [];
        createOnlineMeeting(
          accessToken,
          formData,
          freshStudentList,
          username
        ).then((onlineMeeting) => {
          client
            .api("/me/onlineMeetings")
            .version("beta") // 🔑 Switch to beta
            .post(onlineMeeting)
            .then((response) => {
              setIsLoading(true);
              const selectedStudentsData = enrolledStudents
                .filter((student) =>
                  selectedStudentIds.includes(student.user_id)
                )
                .map((student) => ({
                  user_id: student.user_id,
                  time_slot: student.time_slot,
                  batch_id: student.batch_id,
                  team_url: response.joinWebUrl,
                }));

              const coreSubjectArray = formData.core_subject.map(
                (opt) => opt.label
              );
              const panelMemberArray = formData.panel_member_id.map(
                (opt) => opt.value
              );

              const formatTimeForApi = (time) => {
                if (!time) return "";
                return time.substring(0, 5);
              };
              const updatedOtherApplicableBatches =
                selectedOtherApplicableBatch.filter((id) => id !== BATCH_ID);
              const meeting_id = response.id;
              const payload = {
                id: id || "",
                batch_id: BATCH_ID,
                interview_id: INTERVIEW_ID,
                panel_name: formData.panel_name,
                panel_venue: formData.panel_venue,
                panel_venue_url: formData.panel_venue_url || "",
                core_subject: coreSubjectArray,
                interview_date: moment(formData.interview_date).format(
                  "YYYY-MM-DD"
                ),
                start_time: formatTimeForApi(formData.start_time),
                end_time: formatTimeForApi(formData.end_time),
                slot_duration: formData.slot_duration
                  ? Number(formData.slot_duration)
                  : null,
                other_applicable_batches:
                  updatedOtherApplicableBatches.length > 0
                    ? updatedOtherApplicableBatches.map((item) => item.value)
                    : "",
                panel_member_id: panelMemberArray,
                created_by: userid,
                students_enrolled: selectedStudentsData,
              };
              setIsSubmitting(true);
              AxiosInstance.post("/api/mockinterview/panel/create", payload)
                .then((res) => {
                  if (res.data?.status) {
                    setIsLoading(false);
                    setIsSubmitting(true);
                    toast.success(
                      res.data?.message || "Panel saved successfully!"
                    );
                    navigate(-1);
                  } else {
                    toast.error(
                      res.data?.message ||
                        "Failed to save panel. Please try again."
                    );
                    setIsLoading(false);
                    setIsSubmitting(true);
                  }
                })
                .catch((error) => {
                  setIsLoading(false);
                  setIsSubmitting(true);
                  console.log(error);
                  return error;
                });
            })
            .catch((error) => {
              setIsLoading(false);
              setIsSubmitting(true);
              console.log(error);
            });
        });
      } else {
        const payload = {
          id: id || "",
          batch_id: BATCH_ID,
          interview_id: INTERVIEW_ID,
          panel_name: formData.panel_name,
          panel_venue: formData.panel_venue,
          panel_venue_url: formData.panel_venue_url || "",
          core_subject: coreSubjectArray,
          interview_date: moment(formData.interview_date).format("YYYY-MM-DD"),
          start_time: formatTimeForApi(formData.start_time),
          end_time: formatTimeForApi(formData.end_time),
          slot_duration: formData.slot_duration
            ? Number(formData.slot_duration)
            : null,
          other_applicable_batches:
            updatedOtherApplicableBatches.length > 0
              ? updatedOtherApplicableBatches.map((item) => item.value)
              : "",
          panel_member_id: panelMemberArray,
          created_by: userid,
          students_enrolled: selectedStudentsData,
        };

        setIsSubmitting(true);
        try {
          const res = await AxiosInstance.post(
            "/api/mockinterview/panel/create",
            payload
          );
          if (res.data?.status) {
            toast.success(res.data?.message || "Panel saved successfully!");
            navigate(-1);
          } else {
            toast.error(
              res.data?.message || "Failed to save panel. Please try again."
            );
          }
        } catch (error) {
          console.error("Error saving panel:", error);
          toast.error(
            error?.response?.data?.message ||
              "Failed to save panel. Please try again."
          );
        } finally {
          setIsSubmitting(false);
        }
      }
    } else {
      setError(errors);
    }
  };

  const fetchPanelDataWithFilters = async (
    filters = {},
    isInitialLoad = false
  ) => {
    if (!id) return; // Only for edit mode

    if (isInitialLoad) {
      setIsLoading(true);
    }

    try {
      const payload = {
        id: id || "",
        gender: filters.gender ? [filters.gender] : "",
        batch_name: filters.batch_name ? [filters.batch_name] : "",
        medium_studied: filters.medium_studied ? [filters.medium_studied] : "",
        core_subject: filters.core_subject ? [filters.core_subject] : "",
        panel_mark_status: filters.mark_status || "",
        student_mark_status: filters.student_mark_status || "",
      };

      const res = await AxiosInstance.post(
        "api/mockinterview/panel/findById",
        payload
      );

      if (res.data.status === true && res.data.data) {
        const data = res.data.data;
        const enroll_student = data.enroll_student || [];
        const panel_details = data.panel_details || [];

        // Format enrolled students with consistent structure
        const formattedStudents = enroll_student.map((student, index) => ({
          user_id: student.student_user_id,
          admission_id: student.admission_id,
          name: student.student_name,
          email: student.student_email,
          phone_no: student.student_mobile,
          gender: student.student_gender,
          stud_pref_medium: student.medium_studied,
          core_subject: student.core_sub,
          batch_name: student.batch_name,
          batch_id: student.batch_id, // Make sure to include batch_id
          time_slot: student.time_slot || "",
          // originalIndex: student.originalIndex || 0,
          serialNumber: index + 1,
        }));

        // Set enrolled students
        setEnrolledStudents(formattedStudents);
        setCurrentPage(1);

        // Always extract filter options from current data (even filtered)
        extractFilterOptionsFromData(formattedStudents);

        // Set original data only if no filters applied
        if (
          !filters.gender &&
          !filters.batch_name &&
          !filters.core_subject &&
          !filters.medium_studied
        ) {
          setOriginalStudentData(formattedStudents);
        }

        // Pre-select all students that have time slots
        const studentIdsWithTimeSlot = formattedStudents
          .filter((s) => s.time_slot)
          .map((s) => s.user_id);
        setSelectedStudentIds(studentIdsWithTimeSlot);

        // Only update form data on initial load
        if (isInitialLoad && panel_details.length > 0) {
          // Format panel members for Select component
          const panel_member = data.panel_member || [];
          const formattedPanelMembers = panel_member.map((member) => ({
            value: member.faculty_id,
            label: member.faculty_name,
          }));

          // Format core_subject
          let formattedCoreSubjects = [];
          if (panel_details[0].core_subject) {
            formattedCoreSubjects = panel_details[0].core_subject
              .split(",")
              .map((name) => ({
                value: name.trim(),
                label: name.trim(),
              }));
          }

          // Format other applicable batches
          const otherAppBatch = data.otherAppBatch || [];
          let formattedOtherBatches = [];
          if (otherAppBatch.length > 0) {
            formattedOtherBatches = otherAppBatch.map((batch) => ({
              value: batch.batch_id,
              label: batch.batch_name,
            }));
          }
          setSelectedOtherApplicableBatch(formattedOtherBatches);

          // Set batch IDs
          const mainBatchId = data.batch_id;
          const otherBatchIds = otherAppBatch.map((b) => b.batch_id);
          const combinedBatchIds = Array.from(
            new Set([mainBatchId, ...otherBatchIds])
          );
          setCurrentBatchId(combinedBatchIds);

          // Format time - ensure HH:mm:ss format
          const formatTime = (time) => {
            if (!time) return "";
            if (time.length === 5) {
              return `${time}:00`;
            }
            return time;
          };

          setFormData((prev) => ({
            ...prev,
            panel_name: panel_details[0].panel_name || "",
            panel_member_id: formattedPanelMembers,
            panel_venue: panel_details[0].panel_venue || "",
            panel_venue_url: panel_details[0].panel_venue_url || "",
            start_time: formatTime(panel_details[0].start_time),
            end_time: formatTime(panel_details[0].end_time),
            core_subject: formattedCoreSubjects,
            slot_duration: panel_details[0].slot_duration || "",
            interview_date: panel_details[0].interview_date || "",
            hall_ticket_status: data.hall_ticket_status || "",
          }));
        }
      } else {
        // No data found with filters
        setEnrolledStudents([]);
        setOriginalStudentData([]);
      }
    } catch (error) {
      console.error("Error fetching panel data:", error);
      toast.error("Failed to fetch panel data with filters");
      setEnrolledStudents([]);
    } finally {
      setIsLoading(false);
      setIsInitialStudentLoading(false);
      setIsStudentListLoading(false);
    }
  };

  // Generate time slots when start_time, end_time, or slot_duration changes
  useEffect(() => {
    const { start_time, end_time, slot_duration } = formData;
    if (start_time && end_time && slot_duration && slot_duration.length >= 2) {
      const durationNum = parseInt(slot_duration, 10);
      if (!isNaN(durationNum) && durationNum >= 10) {
        const slots = generateTimeSlots(
          start_time.substring(0, 5),
          end_time.substring(0, 5),
          slot_duration
        );
        setTimeSlotOptions(slots);
        const newSlotValues = slots.map((s) => s.value);
        setEnrolledStudents((prev) =>
          prev.map((student) => ({
            ...student,
            time_slot: newSlotValues.includes(student.time_slot)
              ? student.time_slot
              : "",
          }))
        );
      } else {
        setTimeSlotOptions([]);
      }
    } else {
      setTimeSlotOptions([]);
      setEnrolledStudents((prev) =>
        prev.map((student) => ({
          ...student,
          time_slot: "",
        }))
      );
    }
  }, [formData.start_time, formData.end_time, formData.slot_duration]);

  return isLoading ? (
    <div className={styles.loaderOverlay}>{isLoading && <Loader />}</div>
  ) : (
    <>
      <div className={`${styles.CourseInfoSec} BathHeader global_container`}>
        <div className="row">
          <div className="col-md-6 col-12">
            <h2 className="TitleHeader">
              {id ? "Edit Panel" : "Create New Panel"}
            </h2>
          </div>
          <div className="col-md-6 col-12 ListBtn">
            <ul className="List-Button">
              <li className="ListBtnItems">
                <Link
                  to="#"
                  className="secondaryButton"
                  variant="secondary"
                  onClick={() => {
                    if (id) {
                      navigateToPreviousScreen();
                    } else {
                      navigate(-1);
                    }
                  }}
                >
                  {id ? "Back to View Panel" : "Back to View Interview"}
                </Link>
              </li>
              <li className="ListBtnItems">
                <Link
                  to="javascript:void(0)"
                  className={`primaryButton text-center ${
                    !isSavePanelEnabled() ? styles.disabledButton : ""
                  }`}
                  variant="primary"
                  onClick={isSavePanelEnabled() ? handleSubmit : undefined}
                  style={{
                    opacity: isSavePanelEnabled() ? 1 : 0.6,
                    cursor: isSavePanelEnabled() ? "pointer" : "not-allowed",
                  }}
                >
                  Save Panel
                </Link>
              </li>
            </ul>
          </div>
        </div>

        {/* Panel Details Section */}
        <fieldset className="mt-3">
          <legend className="w-auto">Panel Details</legend>
          <form className={`form-label confirm_value row g-3 `}>
            <div className={`col-md-6 ${id ? styles.disabled_btn : ""}`}>
              <label htmlFor="panelName" className="form-label confirm_value">
                Panel Name
              </label>
              <input
                ref={panelNameRef}
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                type="text"
                id="panelName"
                name="panel_name"
                value={formData.panel_name}
                onChange={handleInputChange}
                placeholder="Enter Panel Name"
              />
              {error.panel_name && (
                <small className={styles.errors}>{error.panel_name}</small>
              )}
            </div>

            <div
              className={`col-md-6 ${
                formData.hall_ticket_status ? styles.disabled_btn : ""
              }`}
            >
              <label
                htmlFor="panelExperts"
                className="form-label confirm_value"
              >
                Panel Experts
              </label>
              <Select
                ref={panelExpertsRef}
                id="staffs"
                name="panel_member_id"
                value={formData.panel_member_id}
                onChange={handlePanelMemberChange}
                options={sortedStaff}
                isMulti
                isSearchable
                placeholder="Select Panel Members"
                maxMenuHeight={200}
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                components={{ Option: CheckboxOption }}
                styles={customStyles}
                filterOption={(option, inputValue) =>
                  option.label.toLowerCase().includes(inputValue.toLowerCase())
                }
              />

              {error.panel_member_id && (
                <small className="errors m-0">{error.panel_member_id}</small>
              )}
            </div>

            <div className={`col-md-6 ${id ? styles.disabled_btn : ""}`}>
              <label htmlFor="venue" className="form-label confirm_value">
                Venue
              </label>
              <input
                ref={venueRef}
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                type="text"
                id="venue"
                name="panel_venue"
                value={formData.panel_venue}
                onChange={handleInputChange}
                placeholder="Enter Venue"
              />
              {error.panel_venue && (
                <small className={styles.errors}>{error.panel_venue}</small>
              )}
            </div>

            <div className={`col-md-6 ${id ? styles.disabled_btn : ""}`}>
              <label htmlFor="venueUrl" className="form-label confirm_value">
                Venue URL
              </label>
              <input
                ref={venueUrlRef}
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                type="text"
                id="venueUrl"
                name="panel_venue_url"
                value={formData.panel_venue_url}
                onChange={handleVenueUrlChange}
                placeholder="Enter Venue URL (e.g., https://example.com)"
              />
              {error.panel_venue_url && (
                <small className={styles.errors}>{error.panel_venue_url}</small>
              )}
            </div>

            <div className={`col-md-6 ${id ? styles.disabled_btn : ""}`}>
              <label
                htmlFor="coreSubjects"
                className="form-label confirm_value"
              >
                Core Subjects
              </label>
              <Select
                ref={coreSubjectsRef}
                id="coreSubjects"
                name="core_subject"
                value={formData.core_subject}
                onChange={handleCoreSubjectChange}
                options={coreSubjectOptions}
                isMulti
                isSearchable={true}
                placeholder="Select Core Subjects"
                maxMenuHeight={200}
                filterOption={(option, searchText) =>
                  option.label.toLowerCase().includes(searchText.toLowerCase())
                }
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                components={{ Option: CheckboxOption }}
                styles={customStyles}
              />
              {error.core_subject && (
                <small className={styles.errors}>{error.core_subject}</small>
              )}
            </div>

            <div className={`col-md-6 ${id ? styles.disabled_btn : ""}`}>
              <label htmlFor="eventDate" className="form-label confirm_value">
                Date
              </label>
              <DatePickerSample
                txtAdMDob={interviewDateRef}
                handleChange={(date) => handleDateChange(date)}
                fieldInput={
                  formData.interview_date
                    ? moment(formData.interview_date).format("DD/MM/YYYY")
                    : ""
                }
                minDate={minDate}
                disabledProperty
              />
              {error.interview_date && (
                <small className={styles.errors}>{error.interview_date}</small>
              )}
            </div>

            <div className={`col-md-6 ${id ? styles.disabled_btn : ""}`}>
              <label className="form-label confirm_value">Start Time</label>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <MobileTimePicker
                  value={
                    formData.start_time
                      ? dayjs(formData.start_time, "HH:mm:ss")
                      : null
                  }
                  onChange={(time) => handleTimeChange("start_time", time)}
                  format="hh:mm A"
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      placeholder: "Select Start Time",
                      InputProps: {
                        readOnly: true,
                        endAdornment: <AccessTime sx={{ color: "#0d6efd" }} />,
                        className: "form-control",
                      },
                      sx: {
                        /* remove MUI outline */
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },

                        /* 🔥 FIX LEFT GAP */
                        "& .MuiInputBase-root": {
                          marginLeft: 0,
                          paddingLeft: 0,
                        },

                        /* Bootstrap focus glow */
                        "&.Mui-focused": {
                          boxShadow: "0 0 0 .25rem rgba(13,110,253,.25)",
                          borderRadius: "0.375rem",
                        },

                        "& input": {
                          padding: "0.375rem 0.75rem",
                          fontSize: "14px",
                          cursor: "pointer",
                        },
                      },
                    },
                  }}
                />
              </LocalizationProvider>

              {error.start_time && (
                <small className={styles.errors}>{error.start_time}</small>
              )}
            </div>

            <div className={`col-md-6 ${id ? styles.disabled_btn : ""}`}>
              <label className="form-label confirm_value">End Time</label>

              <LocalizationProvider dateAdapter={AdapterDayjs}>
                <MobileTimePicker
                  value={
                    formData.end_time
                      ? dayjs(formData.end_time, "HH:mm:ss")
                      : null
                  }
                  onChange={(time) => handleTimeChange("end_time", time)}
                  format="hh:mm A"
                  slotProps={{
                    textField: {
                      fullWidth: true,
                      placeholder: "Select End Time",
                      InputProps: {
                        readOnly: true,
                        endAdornment: <AccessTime sx={{ color: "#0d6efd" }} />,
                        className: "form-control",
                      },
                      sx: {
                        /* remove MUI outline */
                        "& .MuiOutlinedInput-notchedOutline": {
                          border: "none",
                        },

                        /* remove left gap */
                        "& .MuiInputBase-root": {
                          marginLeft: 0,
                          paddingLeft: 0,
                        },

                        /* bootstrap focus */
                        "&.Mui-focused": {
                          boxShadow: "0 0 0 .25rem rgba(13,110,253,.25)",
                          borderRadius: "0.375rem",
                        },

                        "& input": {
                          padding: "0.375rem 0.75rem",
                          fontSize: "14px",
                          cursor: "pointer",
                        },
                      },
                    },
                  }}
                />
              </LocalizationProvider>

              {error.end_time && (
                <small className={styles.errors}>{error.end_time}</small>
              )}
            </div>

            <div className={`col-md-6 ${id ? styles.disabled_btn : ""}`}>
              <label
                htmlFor="slotDuration"
                className="form-label confirm_value"
              >
                Slot Duration (In Minutes)
              </label>
              <input
                ref={slotDurationRef}
                className="desc_input_text w-100 rounded-2 input-font-size-sm"
                type="text"
                id="slotDuration"
                name="slot_duration"
                value={formData.slot_duration}
                onChange={handleSlotDurationChange}
                placeholder="Enter Slot Duration (e.g., 10, 15, 30, 60)"
                maxLength={3}
              />
              {error.slot_duration && (
                <small className={styles.errors}>{error.slot_duration}</small>
              )}
            </div>
          </form>
        </fieldset>

        <fieldset className="mt-3">
          <legend className="w-auto">Other Applicable Batches</legend>
          <form className="row g-3">
            <div className="col-md-6">
              <label
                className={`form-label confirm_value ${
                  id || OTHERAPPBATCH?.length > 0 ? styles.disabled_btn : ""
                }`}
              >
                Other Applicable Batches
              </label>

              <Select
                className="shadow-none input-font-size"
                name="otherApplicableBatches"
                value={selectedOtherApplicableBatch}
                onChange={(options) => {
                  if (id || OTHERAPPBATCH?.length > 0) return;
                  handlechangeSelectDropdown(options, "otherApplicableBatches");
                }}
                options={otherBatchOptions}
                isMulti
                isSearchable
                placeholder="Select other applicable batches"
                closeMenuOnSelect={false}
                hideSelectedOptions={false}
                components={{ Option: CheckboxOption }}
                styles={customStyles}
                isDisabled={Boolean(id || OTHERAPPBATCH?.length > 0)}
              />
            </div>

            <div className="col-md-6 d-flex align-items-end">
              <li className="ListBtnItems mb-0">
                <Link
                  to="javascript:void(0)"
                  className={`primaryButton text-center ${
                    id ||
                    OTHERAPPBATCH?.length > 0 ||
                    isStudentListLoading ||
                    currentStudentData?.length === 0
                      ? styles.disabled_btn
                      : ""
                  }`}
                  onClick={(e) => {
                    if (
                      id ||
                      OTHERAPPBATCH?.length > 0 ||
                      isStudentListLoading
                    ) {
                      e.preventDefault();
                      return;
                    }
                    handleGenerateStudentList();
                  }}
                >
                  Generate Student List
                </Link>
              </li>
            </div>

            {/* UPDATED Modal with dynamic batch name */}
            {open && (
              <Modal
                key={`modal-0-${0}`}
                show={open}
                onHide={handleModelClose}
                size="lg"
                centered
              >
                <Modal.Header closeButton>
                  <Modal.Title>
                    <h5 className="fw-bold mb-0" id="exampleModalLabel">
                      Confirm Other Applicable Batches
                    </h5>
                  </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                  <div className="row global_container">
                    <div className="col-12">
                      <div className="mb-3">
                        <p className="mb-3">
                          Are you sure you want to add the below mentioned
                          selected OTHER APPLICABLE BATCHES to{" "}
                          <strong>
                            {currentBatchName || "the selected batch"}
                          </strong>
                          ?
                        </p>
                      </div>

                      <div className="mb-3">
                        <label className="form-label confirm_label ">
                          Other Applicable Batches
                        </label>
                        <div>
                          <span className="form-label confirm_value">
                            {selectedOtherApplicableBatch &&
                            selectedOtherApplicableBatch.length > 0
                              ? selectedOtherApplicableBatch
                                  .map((batch) => batch.name)
                                  .join(", ")
                              : "No batches selected"}
                          </span>
                        </div>
                      </div>

                      <div className="mt-3">
                        <p className="">
                          Once you create a panel, this cannot be edited in the
                          future. The students from the selected batches will
                          appear in all future panel creations for this batch.
                        </p>
                      </div>
                    </div>
                  </div>
                </Modal.Body>
                <Modal.Footer>
                  <ul className="List-Button">
                    <li className="ListBtnItems">
                      <Link
                        onClick={handleModelClose}
                        className="secondaryButton"
                      >
                        Cancel
                      </Link>
                    </li>
                    <li className="ListBtnItems">
                      <Link
                        to="#"
                        onClick={(e) => {
                          e.preventDefault();
                          handleModeSubmit();
                        }}
                        className="primaryButton"
                      >
                        Yes, Confirm
                      </Link>
                    </li>
                  </ul>
                </Modal.Footer>
              </Modal>
            )}
          </form>
        </fieldset>

        {/* Enrolled Students Section with Pagination */}
        <fieldset className="mt-3">
          <legend className="w-auto">Enrolled Student</legend>

          {/* Filter Chips Display */}
          {updateChipData?.length > 0 && (
            <div className="row mt-3">
              <div className="col-md-12 col-sm-12 col-xs-12 paperil_global">
                <Paper
                  sx={{
                    display: "flex",
                    justifyContent: "center",
                    flexWrap: "wrap",
                    listStyle: "none",
                    p: 0.5,
                    m: 0,
                  }}
                  component="ul"
                >
                  {/* {updateChipData.map((data, index) => {
                    return (
                      <ListItem key={index}>
                        <Chip
                          label={
                            <span className={styles.BoldTyText}>
                              {data.name}
                            </span>
                          }
                          onDelete={(e) => {
                            e.preventDefault();
                            handleDeleteChip(data);
                          }}
                        />
                      </ListItem>
                    );
                  })} */}
                  {updateChipData.map((data, index) => {
                    return (
                      <ListItem key={`${data.type}_${data.id}_${index}`}>
                        <Chip
                          label={
                            <span className={styles.BoldTyText}>
                              {data.name}
                            </span>
                          }
                          onDelete={(e) => {
                            e.preventDefault();
                            handleDeleteChip(data)();
                          }}
                        />
                      </ListItem>
                    );
                  })}
                  <ListItem className="clearAll_list">
                    <a
                      href="#"
                      className="clearAll_listItem"
                      onClick={(e) => {
                        e.preventDefault();
                        handleAllClear();
                      }}
                    >
                      Clear All Filters
                    </a>
                  </ListItem>
                </Paper>
              </div>
            </div>
          )}

          <div
            className={`${styles.CourseInfoSec} ${styles.cm_ListViewForm} container-fluid global_container p-0`}
          >
            {isStudentListLoading || isInitialStudentLoading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ minHeight: "200px" }}
              >
                <Loader />
              </div>
            ) : (
              <>
                <div className="row mx-0 mt-2">
                  <div
                    className={`${styles.tableresponsive} col-md-12 table-responsive tableMinHeight px-0`}
                  >
                    <table className="table" id="tableListHeader">
                      <thead>
                        <tr>
                          <th id="th" className={styles.checkboxCell}></th>
                          <th id="th">
                            <span
                              className="textHead_th"
                              onClick={(e) => handleSort(e, "serialNumber")}
                            >
                              S.No
                            </span>
                            <span
                              className="textHead_th material-icons align-middle"
                              onClick={(e) => handleSort(e, "serialNumber")}
                            >
                              import_export
                            </span>
                          </th>
                          <th id="th">
                            <span
                              className="textHead_th"
                              onClick={(e) => handleSort(e, "name")}
                            >
                              Name
                            </span>
                            <span
                              className="textHead_th material-icons align-middle"
                              onClick={(e) => handleSort(e, "name")}
                            >
                              import_export
                            </span>
                          </th>
                          <th id="th">
                            <span
                              className="textHead_th"
                              onClick={(e) => handleSort(e, "admission_id")}
                            >
                              Admission ID
                            </span>
                            <span
                              className="textHead_th material-icons align-middle"
                              onClick={(e) => handleSort(e, "admission_id")}
                            >
                              import_export
                            </span>
                          </th>

                          {/* Batch Name - With Filter */}
                          <th
                            id="th"
                            className={styles.tableThPadding}
                            ref={filterRef_batchName}
                          >
                            <span
                              className="textHead_th"
                              onClick={(e) => handleSort(e, "batch_name")}
                            >
                              Batch Name
                            </span>
                            <span
                              className="textHead_th material-icons align-middle"
                              onClick={(e) => handleSort(e, "batch_name")}
                            >
                              import_export
                            </span>
                            <span
                              className={`textHead_th align-middle material-icons ${
                                batchName_on.length > 0 ||
                                isFilterOpen.batchName
                                  ? styles.active_icons_book
                                  : ""
                              }`}
                              onClick={(e) =>
                                handleFilterToggle(e, "batchName")
                              }
                            >
                              filter_list
                            </span>
                            {isFilterOpen.batchName && (
                              <div className="filterBoxs_testlist mt-3">
                                <div className="col-md-12 form-check filterStatus_list">
                                  <ul className="ulFilterListData">
                                    <li
                                      className={`filterListData ${styles.searchInputSec}`}
                                    >
                                      <input
                                        className={`${styles.searchInput} w-100`}
                                        type="text"
                                        placeholder="Search by batch name"
                                        onChange={handleFilterBatchSearch}
                                        ref={txtBSearch_batch}
                                      />
                                      <Search
                                        className={`${styles.ListsearchIcon}`}
                                      />
                                    </li>
                                    {batchNameFilteredOptions.map((el) => (
                                      <li
                                        className="filterListData"
                                        key={el.id}
                                      >
                                        <input
                                          className="ListCheckbox"
                                          type="checkbox"
                                          name={el.name}
                                          value={el.id}
                                          id={`batch_${el.id}`}
                                          checked={batchName_on.some(
                                            (element) => element.id == el.id
                                          )}
                                          onChange={(e) =>
                                            handleFilterCheckboxChange(
                                              e,
                                              "batchName"
                                            )
                                          }
                                        />
                                        <label
                                          className="form-check-label filterChipText_withoutBG"
                                          htmlFor={`batch_${el.id}`}
                                        >
                                          {el.name}
                                        </label>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                                <div className="borderWidth row">
                                  <ul className="List-Button">
                                    <li className="ListBtnItems">
                                      <Link
                                        to="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleClearFilter("batchName");
                                        }}
                                        className="secondaryButton"
                                      >
                                        Clear
                                      </Link>
                                    </li>
                                    <li className="ListBtnItems">
                                      <Link
                                        to="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleApplyFilter("batchName");
                                        }}
                                        className="primaryButton"
                                      >
                                        Apply Filter
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            )}
                          </th>

                          <th id="th">
                            <span
                              className="textHead_th"
                              onClick={(e) => handleSort(e, "phone_no")}
                            >
                              Phone Number
                            </span>
                            <span
                              className="textHead_th material-icons align-middle"
                              onClick={(e) => handleSort(e, "phone_no")}
                            >
                              import_export
                            </span>
                          </th>
                          <th id="th">
                            <span
                              className="textHead_th"
                              onClick={(e) => handleSort(e, "email")}
                            >
                              Email
                            </span>
                            <span
                              className="textHead_th material-icons align-middle"
                              onClick={(e) => handleSort(e, "email")}
                            >
                              import_export
                            </span>
                          </th>

                          {/* Gender - With Filter */}
                          <th
                            id="th"
                            className={styles.tableThPadding}
                            ref={filterRef_gender}
                          >
                            <span
                              className="textHead_th"
                              onClick={(e) => handleSort(e, "gender")}
                            >
                              Gender
                            </span>
                            <span
                              className="textHead_th material-icons align-middle"
                              onClick={(e) => handleSort(e, "gender")}
                            >
                              import_export
                            </span>
                            <span
                              className={`textHead_th align-middle material-icons ${
                                gender_on.length > 0 || isFilterOpen.gender
                                  ? styles.active_icons_book
                                  : ""
                              }`}
                              onClick={(e) => handleFilterToggle(e, "gender")}
                            >
                              filter_list
                            </span>
                            {isFilterOpen.gender && (
                              <div className="filterBoxs_testlist mt-3">
                                <div className="col-md-12 form-check filterStatus_list">
                                  <ul className="ulFilterListData">
                                    {genderOptions.map((el) => (
                                      <li
                                        className="filterListData"
                                        key={el.id}
                                      >
                                        <input
                                          className="ListCheckbox"
                                          type="checkbox"
                                          name={el.name}
                                          value={el.id}
                                          id={`gender_${el.id}`}
                                          checked={gender_on.some(
                                            (element) => element.id == el.id
                                          )}
                                          onChange={(e) =>
                                            handleFilterCheckboxChange(
                                              e,
                                              "gender"
                                            )
                                          }
                                        />
                                        <label
                                          className="form-check-label filterChipText_withoutBG"
                                          htmlFor={`gender_${el.id}`}
                                        >
                                          {el.name}
                                        </label>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                                <div className="borderWidth row">
                                  <ul className="List-Button">
                                    <li className="ListBtnItems">
                                      <Link
                                        to="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleClearFilter("gender");
                                        }}
                                        className="secondaryButton"
                                      >
                                        Clear
                                      </Link>
                                    </li>
                                    <li className="ListBtnItems">
                                      <Link
                                        to="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleApplyFilter("gender");
                                        }}
                                        className="primaryButton"
                                      >
                                        Apply Filter
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            )}
                          </th>

                          {/* Medium Studied - With Filter */}
                          <th
                            id="th"
                            className={styles.tableThPadding}
                            ref={filterRef_medium}
                          >
                            <span
                              className="textHead_th"
                              onClick={(e) => handleSort(e, "stud_pref_medium")}
                            >
                              Medium Studied
                            </span>
                            <span
                              className="textHead_th material-icons align-middle"
                              onClick={(e) => handleSort(e, "stud_pref_medium")}
                            >
                              import_export
                            </span>
                            <span
                              className={`textHead_th align-middle material-icons ${
                                medium_on.length > 0 || isFilterOpen.medium
                                  ? styles.active_icons_book
                                  : ""
                              }`}
                              onClick={(e) => handleFilterToggle(e, "medium")}
                            >
                              filter_list
                            </span>
                            {isFilterOpen.medium && (
                              <div className="filterBoxs_testlist mt-3">
                                <div className="col-md-12 form-check filterStatus_list">
                                  <ul className="ulFilterListData">
                                    {mediumOptions.map((el) => (
                                      <li
                                        className="filterListData"
                                        key={el.id}
                                      >
                                        <input
                                          className="ListCheckbox"
                                          type="checkbox"
                                          name={el.name}
                                          value={el.id}
                                          id={`medium_${el.id}`}
                                          checked={medium_on.some(
                                            (element) => element.id == el.id
                                          )}
                                          onChange={(e) =>
                                            handleFilterCheckboxChange(
                                              e,
                                              "medium"
                                            )
                                          }
                                        />
                                        <label
                                          className="form-check-label filterChipText_withoutBG"
                                          htmlFor={`medium_${el.id}`}
                                        >
                                          {el.name}
                                        </label>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                                <div className="borderWidth row">
                                  <ul className="List-Button">
                                    <li className="ListBtnItems">
                                      <Link
                                        to="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleClearFilter("medium");
                                        }}
                                        className="secondaryButton"
                                      >
                                        Clear
                                      </Link>
                                    </li>
                                    <li className="ListBtnItems">
                                      <Link
                                        to="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleApplyFilter("medium");
                                        }}
                                        className="primaryButton"
                                      >
                                        Apply Filter
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            )}
                          </th>

                          {/* Core Subject - With Filter */}
                          <th
                            id="th"
                            className={styles.tableThPadding}
                            ref={filterRef_coreSubject}
                          >
                            <span
                              className="textHead_th"
                              onClick={(e) => handleSort(e, "core_subject")}
                            >
                              Core Subject
                            </span>
                            <span
                              className="textHead_th material-icons align-middle"
                              onClick={(e) => handleSort(e, "core_subject")}
                            >
                              import_export
                            </span>
                            <span
                              className={`textHead_th align-middle material-icons ${
                                coreSubject_on.length > 0 ||
                                isFilterOpen.coreSubject
                                  ? styles.active_icons_book
                                  : ""
                              }`}
                              onClick={(e) =>
                                handleFilterToggle(e, "coreSubject")
                              }
                            >
                              filter_list
                            </span>
                            {isFilterOpen.coreSubject && (
                              <div className="filterBoxs_testlist mt-3">
                                <div className="col-md-12 form-check filterStatus_list">
                                  <ul className="ulFilterListData">
                                    <li
                                      className={`filterListData ${styles.searchInputSec}`}
                                    >
                                      <input
                                        className={`${styles.searchInput} w-100`}
                                        type="text"
                                        placeholder="Search by core subject"
                                        onChange={handleFilterCoreSubjectSearch}
                                        ref={txtBSearch_coreSubj}
                                      />
                                      <Search
                                        className={`${styles.ListsearchIcon}`}
                                      />
                                    </li>
                                    {coreSubjectFilteredOptions.map((el) => (
                                      <li
                                        className="filterListData"
                                        key={el.id}
                                      >
                                        <input
                                          className="ListCheckbox"
                                          type="checkbox"
                                          name={el.name}
                                          value={el.id}
                                          id={`coreSubject_${el.id}`}
                                          checked={coreSubject_on.some(
                                            (element) => element.id == el.id
                                          )}
                                          onChange={(e) =>
                                            handleFilterCheckboxChange(
                                              e,
                                              "coreSubject"
                                            )
                                          }
                                        />
                                        <label
                                          className="form-check-label filterChipText_withoutBG"
                                          htmlFor={`coreSubject_${el.id}`}
                                        >
                                          {el.name}
                                        </label>
                                      </li>
                                    ))}
                                  </ul>
                                </div>
                                <div className="borderWidth row">
                                  <ul className="List-Button">
                                    <li className="ListBtnItems">
                                      <Link
                                        to="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleClearFilter("coreSubject");
                                        }}
                                        className="secondaryButton"
                                      >
                                        Clear
                                      </Link>
                                    </li>
                                    <li className="ListBtnItems">
                                      <Link
                                        to="#"
                                        onClick={(e) => {
                                          e.preventDefault();
                                          handleApplyFilter("coreSubject");
                                        }}
                                        className="primaryButton"
                                      >
                                        Apply Filter
                                      </Link>
                                    </li>
                                  </ul>
                                </div>
                              </div>
                            )}
                          </th>

                          <th id="th">
                            <span className="textHead_th">Time Slot</span>
                          </th>
                        </tr>
                      </thead>

                      <tbody>
                        {currentStudentData?.length === 0 ? (
                          <tr>
                            <td colSpan="11" className={styles.staticCell}>
                              No records to display
                            </td>
                          </tr>
                        ) : (
                          currentStudentData?.map((student, index) => (
                            <tr key={student.user_id || index}>
                              <td id="td" className={styles.checkboxCell}>
                                <input
                                  type="checkbox"
                                  className={styles.customCheckbox}
                                  checked={selectedStudentIds.includes(
                                    student.user_id
                                  )}
                                  onChange={() =>
                                    handleStudentCheckbox(student.user_id)
                                  }
                                  disabled={!!id}
                                />
                              </td>
                              <td id="td">{student.serialNumber}</td>
                              <td id="td">
                                <span
                                  className={styles.ellipsis}
                                  title={student.name}
                                >
                                  {student.name || "-"}
                                </span>
                              </td>
                              <td id="td">{student.admission_id || "-"}</td>
                              <td id="td">
                                <span
                                  className={styles.ellipsis}
                                  title={student.batch_name}
                                >
                                  {student.batch_name || "-"}
                                </span>
                              </td>
                              <td id="td">{student.phone_no || "-"}</td>
                              <td id="td">
                                <span
                                  className={styles.ellipsis}
                                  title={student.email}
                                >
                                  {student.email || "-"}
                                </span>
                              </td>
                              <td id="td">{student.gender || "-"}</td>
                              <td id="td">{student.stud_pref_medium || "-"}</td>
                              <td id="td">{student.core_subject || "-"}</td>
                              <td id="td">
                                <span
                                  title={
                                    student.time_slot || "Select Time Slot"
                                  }
                                >
                                  <Select
                                    value={
                                      student.time_slot
                                        ? {
                                            value: student.time_slot,
                                            label: student.time_slot,
                                          }
                                        : null
                                    }
                                    onChange={(selected) =>
                                      handleTimeSlotChange(
                                        student.user_id,
                                        selected
                                      )
                                    }
                                    options={getAvailableSlotsForStudent(
                                      student.user_id
                                    )}
                                    placeholder="Select Time Slot"
                                    isClearable
                                    isSearchable={false}
                                    styles={timeSlotSelectStyle}
                                    menuPlacement="auto"
                                    menuPortalTarget={document.body}
                                    isDisabled={timeSlotOptions.length === 0}
                                    noOptionsMessage={() =>
                                      "No slots available"
                                    }
                                  />
                                </span>
                              </td>
                            </tr>
                          ))
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>

                {/* Pagination */}
                <div className="row mt-2">
                  <Pagination
                    rowsPerPage={rowsPerPage}
                    handlePageCount={handlePageCount}
                    startPage={
                      enrolledStudents && enrolledStudents?.length > 0
                        ? currentPage * rowsPerPage + 1 - rowsPerPage
                        : 0
                    }
                    endPage={
                      enrolledStudents && enrolledStudents?.length > 0
                        ? enrolledStudents?.length < currentPage * rowsPerPage
                          ? enrolledStudents?.length
                          : currentPage * rowsPerPage
                        : 0
                    }
                    totalRecords={
                      enrolledStudents && enrolledStudents?.length > 0
                        ? enrolledStudents?.length
                        : 0
                    }
                    handlePrev={(e) => handlePrev(currentPage - 1)}
                    currentPrevPage={currentPage === 1}
                    prevButton={`${styles.prev_buttonViewAllbook} ${styles.materialIconsRightAndLeft} me-2`}
                    handleNext={() => handleNext(currentPage + 1)}
                    currentNextPage={
                      totalPages == 0 || currentPage === totalPages
                    }
                  />
                </div>
              </>
            )}
          </div>
        </fieldset>

        <div className="row">
          <div className="col-offset-md-6 col-12 ListBtn mt-3">
            <ul className="List-Button">
              <li className="ListBtnItems">
                <Link
                  to="#"
                  className="secondaryButton"
                  variant="secondary"
                  onClick={() => {
                    if (id) {
                      navigateToPreviousScreen();
                    } else {
                      navigate(-1);
                    }
                  }}
                >
                  {id ? "Back to View Panel" : "Back to View Interview"}
                </Link>
              </li>
              <li className="ListBtnItems">
                <Link
                  to="#"
                  className={`primaryButton text-center ${
                    !isSavePanelEnabled() ? styles.disabledButton : ""
                  }`}
                  variant="primary"
                  onClick={isSavePanelEnabled() ? handleSubmit : undefined}
                  style={{
                    opacity: isSavePanelEnabled() ? 1 : 0.6,
                    cursor: isSavePanelEnabled() ? "pointer" : "not-allowed",
                  }}
                >
                  Save Panel
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </>
  );
}

export default PanelInfoCreate;
